import React from "react";

function AutosizingTextarea({ value, className = "", ...props }) {
  const textareaRef = React.useRef(null);

  const resizeTextarea = React.useCallback(() => {
    const textarea = textareaRef.current;
    if (!textarea) return;

    textarea.style.height = "auto";
    textarea.style.height = `${textarea.scrollHeight}px`;
  }, []);

  React.useLayoutEffect(() => {
    resizeTextarea();
  }, [value, resizeTextarea]);

  React.useEffect(() => {
    const textarea = textareaRef.current;
    if (!textarea) return undefined;

    if (typeof ResizeObserver === "undefined") {
      window.addEventListener("resize", resizeTextarea);
      return () => window.removeEventListener("resize", resizeTextarea);
    }

    let previousWidth = null;
    const resizeObserver = new ResizeObserver(([entry]) => {
      const nextWidth = entry.contentRect.width;
      if (nextWidth === previousWidth) return;

      previousWidth = nextWidth;
      resizeTextarea();
    });
    resizeObserver.observe(textarea);

    return () => resizeObserver.disconnect();
  }, [resizeTextarea]);

  return (
    <textarea
      ref={textareaRef}
      className={`${className} overflow-hidden`}
      rows={2}
      value={value}
      {...props}
    />
  );
}

export default AutosizingTextarea;
